// src/lib/configurator.js
import { fetchJsonWithRetry } from './httpRetry';

const API_BASE = process.env.REACT_APP_PORTAIL_API_URL || 'https://support.meteris.fr';

// Registre #20266 (51f20d33) : un 502/504 du proxy part SANS en-tete CORS et
// fetch() leve « Failed to fetch ». GET retente ; POST jamais rejoue.
const MESSAGE_POST_INCERTAIN =
  "La demande n'a pas pu être confirmée. Vérifiez votre boîte mail avant de réessayer, ou appelez le 01 83 62 33 27.";
const CONTEXT = 'b2b'; // ce site est B2B — meaux-informatique passera 'b2c'

export async function fetchConfiguratorStep(stepId = 'root') {
  const url = stepId === 'root'
    ? `${API_BASE}/api/public/it-bookings/configurator/root?context=${CONTEXT}`
    : `${API_BASE}/api/public/it-bookings/configurator/${encodeURIComponent(stepId)}?context=${CONTEXT}`;
  try {
    return await fetchJsonWithRetry(url, { headers: { Accept: 'application/json' } });
  } catch (e) {
    if (e.status && e.status < 500) throw new Error(`Configurateur indisponible (HTTP ${e.status})`);
    throw e;
  }
}

export async function submitCallbackB2B(payload) {
  // ATTENTION : Content-Type explicite — NE PAS spread d'options après headers
  // sinon le Content-Type est écrasé et le backend reçoit text/plain → 422 Pydantic
  let r;
  try {
    r = await fetch(`${API_BASE}/api/public/it-bookings/configurator/callback-b2b`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify(payload),
    });
  } catch (e) {
    if (e instanceof TypeError) throw new Error(MESSAGE_POST_INCERTAIN);
    throw e;
  }
  if (r.status === 429) {
    throw new Error('Trop de demandes envoyées récemment. Merci de patienter quelques minutes.');
  }
  if (r.status === 422) {
    const data = await r.json().catch(() => ({}));
    throw new Error(data.detail?.[0]?.msg || 'Données invalides, vérifiez le formulaire.');
  }
  if (!r.ok) {
    throw new Error(`Erreur serveur (HTTP ${r.status})`);
  }
  return r.json();
}
